export default {
  OPEN_USER_SEARCH_DIALOG: 'OpenUserSearchDialog',
  CLOSE_USER_SEARCH_DIALOG: 'CloseUserSearchDialog',
  LOAD_USER_SEARCH_DIALOG_USERS_START: 'LoadUserSearchDialogUsersStart',
  LOAD_USER_SEARCH_DIALOG_USERS_END: 'LoadUserSearchDialogUsersEnd',
  ADD_USER_SEARCH_DIALOG_USER_START: 'AddUserSearchDialogUserStart',
  ADD_USER_SEARCH_DIALOG_USER_END: 'AddUserSearchDialogUserEnd'
};